<template>
  <div>
    <h2>This is coa view</h2>
  </div>
</template>

<script>
export default {
  name: "CoaForm"
};
</script>

<style>
</style>
